import Api from "./api.js";

/**
 * HubSpot embedded forms — reached as `ThryvApi.hubspot` on every page of both themes. Loads the
 * embed on first create(); claims no global (`window.hbspt` is HubSpot's).
 *
 *   const form = await ThryvApi.hubspot.create({
 *     target: "#signup",                 // element or selector
 *     form: "ba-contact",                // a config/hubspot.php name — or formId: "GUID"
 *     fields: { state: "Texas" },        // hidden values, written into EMPTY fields only
 *     force: ["state"],                  // …unless named here (or force: true for all)
 *     owner: sfid,                       // → direct_assignment_rep, always overwritten
 *     utm: true,                         // URL utm_* > fields utm_*; utm_medium "website" by
 *                                        // default; irclickid → impact_id; current_url /
 *                                        // conversion_url = this page
 *     country: true,                     // country_code = the site country
 *     redirect: "/thank-you/",           // after the dataLayer push lands (2s cap)
 *     options: { submitText: "Send" },   // extra hbspt.forms.create options; region, portalId,
 *                                        // formId, target and the three callbacks are reserved
 *     onReady(form, ctx) {},
 *     onBeforeSubmit(form, data, ctx) {},
 *     onSubmitted(form, data, ctx) {},
 *   });                                  // the <form>, or null if HubSpot failed — never rejects
 *
 * ORDER, per phase: built-ins → the caller's callback (a throw is logged, never propagated) → a
 * bubbling DOM event on the target — `hubspot:ready`, `hubspot:submitted`, and `hubspot:failed`
 * on a load error or timeout — detail `{ form, formId, name, data? }`. On submit the dataLayer
 * push comes before all of that, so no callback can drop it (tracking.js).
 *
 *   ThryvApi.hubspot.fill(form, { state: "Texas" }, { force: ["state"] });
 *   ThryvApi.hubspot.utms();             // { utm_source, …, impact_id } from the URL
 *   ThryvApi.hubspot.ready();            // is hbspt on the page?
 *
 * Templates use <x-hubspot-form> instead, which calls create() from its Alpine component.
 * Guide: docs/guides/thryv-api.md#hubspot.
 */
export const HubSpot = {
  ...Api,

  /** Publishes no global, so there is nothing to do. */
  boot() {
    return this;
  },
};

export default HubSpot;
